import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import { toast } from "@/lib/toast";
import type { Favorite } from "@/types";

export type FavKind = "search" | "repo" | "idea";

export function useFavorites(kind: FavKind) {
  return useQuery({
    queryKey: ["favorites", kind],
    queryFn: () => apiFetch<Favorite[]>(`/api/favorites?kind=${kind}`),
  });
}

export function useAddFavorite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) => apiFetch<Favorite>("/api/favorites", { json: body }),
    onSuccess: (fav) => {
      qc.invalidateQueries({ queryKey: ["favorites", fav.kind] });
      toast.success("Добавлено в избранное");
    },
    onError: () => toast.error("Не удалось добавить в избранное"),
  });
}

export function useRemoveFavorite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiFetch(`/api/favorites/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["favorites"] }),
    onError: () => toast.error("Не удалось убрать из избранного"),
  });
}
